<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <custom-tabs v-model="tabs" grow>
        <template v-slot:staticTabs>
          <v-tab :ripple="false">
            <div class="cornel-left" />
            <div class="cornel-right" />
            <v-icon class="me-2">mdi-plus</v-icon>
            انتخاب تم های پیش فرض
            <help-info
              :element-name="`${serviceName}-${componentName}-default-theme-select`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="انتخاب تم های پیش فرض"
            />
          </v-tab>

          <v-tab :ripple="false">
            <div class="cornel-left" />
            <div class="cornel-right" />
            <v-icon class="me-2">mdi-cogs</v-icon>
            شخصی سازی تم
            <help-info
              :element-name="`${serviceName}-${componentName}-personal-theme`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="شخصی سازی تم"
            />
          </v-tab>
        </template>

        <template v-slot:middle>
          <div class="py-2" />
        </template>

        <template v-slot:staticItems>
          <v-tab-item>
            <v-card>
              <v-card-item
                class="d-flex mr-5 justifyitem-center aligns-item-center"
              >
                <v-text-title class="d-flex mr-5" style="align-items: center"
                  >حالت پیش فرض:</v-text-title
                >
                <v-switch
                  v-model="isDark"
                  :label="value.mode === 'dark' ? 'حالت شب' : 'حالت روز'"
                  color="primary"
                  class="mr-5"
                ></v-switch>
              </v-card-item>
              <v-card-item>
                <v-card-text>
                  <v-card-title
                    >لطفا تم رنگی مخصوص شب را از گزینه های زیر انتخاب
                    کنید</v-card-title
                  >
                </v-card-text>
                <choseDefaultThem type="dark" v-model="value" />
              </v-card-item>
              <v-card-item>
                <v-card-text>
                  <v-card-title
                    >لطفا تم رنگی مخصوص روز را از گزینه های زیر انتخاب
                    کنید</v-card-title
                  >
                </v-card-text>
                <choseDefaultThem type="light" v-model="value" />
              </v-card-item>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <choseCustomColor v-model="value" />
          </v-tab-item>
        </template>
      </custom-tabs>
    </template>
  </help-info-wrapper>
</template>

<script>
import choseDefaultThem from "./choseDefaultThem.vue";
import choseCustomColor from "./choseCustomColor.vue";
export default {
  name: "choseThem",
  components: { choseDefaultThem, choseCustomColor },
  props: {
    value: [Object, Array],
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "create-choiceTheme",
      tabs: 0,
      isDark: false,
    };
  },

  mounted() {
    this.value.mode == "dark" ? (this.isDark = true) : (this.isDark = false);
  },

  watch: {
    isDark: {
      deep: true,
      handler(val) {
        if (val) {
          this.value.mode = "dark";
        } else {
          this.value.mode = "light";
        }
      },
    },
  },
};
</script>

<style></style>
